const Progress = ({ totalSteps, step, titles }: { totalSteps: number; step: number; titles: string[] }) => {
  const isFirst = (i: number) => (i === 0 ? 'rounded-l-2xl' : '');
  const isLast = (i: number) => (i === totalSteps - 1 ? 'rounded-r-2xl' : '');
  const isDone = (i: number) => (step >= i ? 'bold bg-green-600' : 'bg-green-100');
  const isCurrent = (i: number) => (step === i ? 'bold bg-yellow-400' : '');

  const baseClasses = `inline-block p-1 w-full border-0 border-r-2 border-solid border-r-white text-center last:border-0 font-bold`;
  return (
    <div className="w-full flex my-8 xl:my-12">
      {Array.from({ length: totalSteps }, (_, i) => (
        <div key={i} className="inline-block w-1/6 text-center">
          <span className={`${baseClasses} ${isFirst(i)} ${isLast(i)} ${isDone(i)} ${isCurrent(i)}`}>
            <div>{i + 1}</div>
          </span>
          <div className="hidden text-sm font-semibold md:block">{titles?.[i] || '-'}</div>
        </div>
      ))}
    </div>
  );
};

export default Progress;
